<template>
    <div>
        <div class="two-factor-auth-input">
        <input
            v-for="(digit, index) in code"
            :key="index"
            ref="input"
            :value="digit"
            @keydown="handleKeyDown(index, $event)"
            maxlength="1"
            type="tel"
            class="digit-input"
        />
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'OtpInput',
    props: {
      code: {
        type: Array,
        default() {
            return ['','','','','','']
        }
      }
    },
    methods: {
      handleKeyDown(index, event) {
        let { key } = event
        if (/[0-9]/.test(key)) {
          this.code.splice(index, 1, key)
          if (index < this.code.length - 1) {
            this.$refs.input[index + 1].focus()
          }
        } else if (key === "Backspace" && this.code[index] === "") {
          this.code.splice(index, 1, "")
          if (index > 0 ) {
            this.$refs.input[index - 1].focus()
          }
        } else if (key === "Backspace" && index < this.code.length) {
          this.code.splice(index, 1, "")
          if (index > 0) {
            this.$refs.input[index - 1].focus()
          }
        } else if (key === "ArrowLeft" && index > 0) {
            this.$refs.input[index - 1].focus()
        } else if (key === "ArrowRight" && index < this.code.length-1) {
            this.$refs.input[index + 1].focus()
        }
        event.preventDefault();
      },
    },
    watch: {
        code(newCode) {
            this.$emit('input', newCode)
        }
    }
  };
  </script>
  
  <style lang="stylus">
  .two-factor-auth-input
    display: flex
    justify-content: center
    margin-bottom: 50px
  
  .digit-input
    width: 6vh
    height: 6vh
    text-align: center
    m-font-size-r(1.3, 1.6)
    margin-right: 5px
    border-radius: 5px

  .error-message
    m-font-size(16, 18)
    color $titan-white
    margin-top 5px
  </style>
  